import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		// eslint-disable-next-line jira/ff/no-preconditioning
		return fg('frontier-currency-field-d1') && fg('fields-settings-currency-field-display');
	},
};
